import PropTypes from 'prop-types';

const CreditCardSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_713_11335)">
        <path
          d="M59.7461 16.543H10.2539C9.12037 16.543 8.20312 17.4602 8.20312 18.5938V51.4062C8.20312 52.5398 9.12037 53.457 10.2539 53.457H59.7461C60.8796 53.457 61.7969 52.5398 61.7969 51.4062V18.5938C61.7969 17.4602 60.8796 16.543 59.7461 16.543Z"
          fill="url(#paint0_linear_713_11335)"
        />
        <path
          d="M26.3863 43.2032C26.3863 42.0696 25.4691 41.1524 24.3355 41.1524H18.5938C17.4602 41.1524 16.543 42.0696 16.543 43.2032C16.543 44.3367 17.4602 45.2539 18.5938 45.2539H24.3355C25.4691 45.2539 26.3863 44.3367 26.3863 43.2032ZM32.5387 45.2539H37.8719C39.0055 45.2539 39.9227 44.3367 39.9227 43.2032C39.9227 42.0696 39.0055 41.1524 37.8719 41.1524H32.5387C31.4051 41.1524 30.4879 42.0696 30.4879 43.2032C30.4879 44.3367 31.4051 45.2539 32.5387 45.2539ZM51.4062 41.1524H46.075C44.9415 41.1524 44.0243 42.0696 44.0243 43.2032C44.0243 44.3367 44.9415 45.2539 46.075 45.2539H51.4062C52.5398 45.2539 53.457 44.3367 53.457 43.2032C53.457 42.0696 52.5398 41.1524 51.4062 41.1524ZM32.9492 30.8985V26.7969C32.9492 25.6634 32.032 24.7461 30.8984 24.7461H18.5938C17.4602 24.7461 16.543 25.6634 16.543 26.7969V30.8985C16.543 32.032 17.4602 32.9493 18.5938 32.9493H30.8984C32.032 32.9493 32.9492 32.032 32.9492 30.8985ZM51.4062 24.7461H43.2031C42.0696 24.7461 41.1523 25.6634 41.1523 26.7969C41.1523 27.9304 42.0696 28.8477 43.2031 28.8477H51.4062C52.5398 28.8477 53.457 27.9304 53.457 26.7969C53.457 25.6634 52.5398 24.7461 51.4062 24.7461ZM59.7461 8.33988H51.4062C50.2727 8.33988 49.3555 9.25712 49.3555 10.3907C49.3555 11.5242 50.2727 12.4414 51.4062 12.4414H59.7461C63.1386 12.4414 65.8984 15.2012 65.8984 18.5938V51.4063C65.8984 54.7988 63.1386 57.5586 59.7461 57.5586H26.7969C25.9678 57.5586 25.2187 58.0572 24.9024 58.8244C24.5839 59.5914 24.7602 60.4726 25.347 61.0594L29.4485 65.161C29.8491 65.5616 30.3738 65.7619 30.8984 65.7619C31.423 65.7619 31.9479 65.5616 32.3483 65.161C33.1494 64.36 33.1494 63.0621 32.3483 62.2611L31.7476 61.6602H59.7461C65.3998 61.6602 70 57.06 70 51.4063V18.5938C70 12.9401 65.3998 8.33988 59.7461 8.33988ZM15.1971 57.5586H10.2539C6.86137 57.5586 4.10156 54.7988 4.10156 51.4063V18.5938C4.10156 15.2012 6.86137 12.4414 10.2539 12.4414H43.2031C44.0322 12.4414 44.7813 11.9428 45.0976 11.1757C45.4161 10.4087 45.2398 9.52742 44.653 8.94062L40.5515 4.83906C39.7504 4.03802 38.4526 4.03802 37.6515 4.83906C36.8505 5.64009 36.8505 6.93796 37.6515 7.739L38.2524 8.33988H10.2539C4.60018 8.33988 0 12.9401 0 18.5938V51.4063C0 57.06 4.60018 61.6602 10.2539 61.6602H15.1971C16.3306 61.6602 17.2479 60.7429 17.2479 59.6094C17.2479 58.4759 16.3306 57.5586 15.1971 57.5586Z"
          fill="url(#paint1_linear_713_11335)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_713_11335"
          x1="35"
          y1="53.457"
          x2="35"
          y2="16.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_713_11335"
          x1="35"
          y1="65.7619"
          x2="35"
          y2="4.23828"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <clipPath id="clip0_713_11335">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

CreditCardSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default CreditCardSvg;
